<template>
    <div class="page-home page">
        <div class="bg">
            <div class="cloud-01">
                <img src="../assets/img/cloud.png" alt="">
            </div>
            <div class="cloud-02">
                <img src="../assets/img/cloud.png" alt="">
            </div>
            <div class="cloud-03">
                <img src="../assets/img/cloud.png" alt="">
            </div>
            <div class="bird">
                <img src="../assets/img/bird.png" alt="">
            </div>
            <div class="bus">
                <img src="../assets/img/bus.png" alt="">
            </div>
        </div>
        <div class="page-inner">
            <span class="rule-btn" @click="goRule">规则详情</span>
            <div class="logo">
                <img src="../assets/img/logo.png" alt="">
            </div>
            <p class="time"><span>2021.1.23-2021.1.31</span></p>
            <h2 class="title">
                <img src="../assets/img/title.png" alt="">
            </h2>
            <h4 class="sub-title">
                <span>回顾你的封面2020，赢现金红包</span>
            </h4>
            <div class="main">
                <p>2020，我们在封面相遇</p>
                <p>你的每一次打开、每一条评论、每一次转发</p>
                <p>都是我们之间最真挚的爱和陪伴</p>
                <p>我们之间的故事</p>
                <p>也由此开始</p>
            </div>
            <div class="start-btn" @click="goView">
                <span>进入2020</span>
            </div>
            <div class="list-btn" v-if="listBtnShow" @click="goList">
                <img src="../assets/img/home_list_btn.png" alt="">
                <span class="close" @click.stop="closeList"></span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import COVERAPP from '@/utils/COVERAPP'

@Options({
    data () {
        return {
            listBtnShow: true
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
    },
    mounted () {
        this.$common.track(this.aid, 'load', '首页')
        this.activityData && this.$common.pageLoaded()
        this.shareData.title && this.$common.onshare(this.shareData, this.aid)
    },
    methods: {
        ...mapMutations(['SET_USERINFO', 'SET_DIALOGDATA']),
        goView () {
            this.$common.track(this.aid, 'click', '进入2020') 
            this.$router.push({
                path: '/view'
            })
        },
        goRule () {
            this.$common.track(this.aid, 'click', '活动规则') 
            this.$router.push({
                path: '/rule'
            })
        },
        closeList () {
            this.listBtnShow = false
        },
        goList () {
            this.$common.track(this.aid, 'click', '红包记录')
            if (!COVERAPP.Attribute.isApp()) {
                this.SET_DIALOGDATA({
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '确定',
                            className : 'download-btn',
                            data: this.activityData.openApp
                        }
                    ]
                })
                return
            }
            if (this.userInfo.token) {
                this.$router.push({
                    path: '/list'
                })
            } else {
                const _this = this
                COVERAPP.Method.OpenLogin({
                    callback (ret: any) {
                        let userinfo = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret
                        if (!_this.$common.isEmpty(userinfo.user_id)) {
                            _this.$common.getUser((res: any) => {
                                _this.SET_USERINFO(res)
                                setTimeout(() => {
                                    _this.$router.push({
                                        path: '/list'
                                    })
                                }, 500)
                            })         																													
                        }
                    }
                })
            }
        }
    }
})
export default class Home extends Vue {}
</script>

<style lang="scss">
.page-home {
    background: #fcfcfc url('../assets/img/home_bg.jpg') no-repeat center bottom;
    background-size: 100% auto;
    position: relative;
    min-height: 100%;
    .page-inner {
        padding: 1.074074rem 0 4.175926rem;
        position: relative;
        text-align: center;
        line-height: 0;
        position: relative;
        z-index: 1;
    }
    .rule-btn {
        font-size: .296296rem;
        color: #000;
        position: absolute;
        left: .425926rem;
        top: 1.203704rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        line-height: 1.4;
        cursor: pointer;
        text-decoration: none;
        &::before {
            content: '';
            width: .277778rem;
            height: .277778rem;
            background: url('../assets/img/rule_icon.png') no-repeat center center;
            background-size: 100% auto;
            margin-right: .074074rem;
        }
    }
    .logo {
        width: 2.277778rem;
        margin: 0 auto 1.1rem;
        font-size: 0;
        line-height: 0;
    }
    .time {
        font-size: .333333rem;
        color: #0d0d0d;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1.4;
        span {
            padding: 0 .138889rem;
        }
        &::before, &::after {
            content: '';
            width: .555556rem;
            height: 1px;
            background-color: #0d0d0d;
        }
    }
    .title {
        width: 8.333333rem;
        font-size: 0;
        line-height: 0;
        margin: .444444rem auto 0;
        animation: bounceIn 1s forwards;
    }
    .sub-title {
        padding-top: .481481rem;
        span {
            font-size: .37037rem;
            color: #eb282b;
            height: .75rem;
            border: 1px solid #eb282b;
            border-radius: .388889rem;
            display: inline-flex;
            padding: 0 .333333rem;
            align-items: center;
            line-height: normal;
        }
    }
    .main {
        font-size: .314815rem;
        color: #000;
        line-height: 2.1;
        margin: 1.103704rem 0 1.790741rem;
        animation: fadeInUp 1s forwards;
    }
    .start-btn {
        height: .888889rem;
        display: inline-flex;
        justify-content: center;
        background: linear-gradient(#fd4144, #d7151b);
        border-radius: .444444rem;
        padding: 0 .509259rem 0 .555556rem;
        align-items: center;
        position: relative;
        cursor: pointer;
        animation: heartBeat 1s infinite;
        &::before {
            content: '';
            position: absolute;
            left: .12963rem;
            top: .083333rem;
            width: .694444rem;
            height: .277778rem;
            background: url('../assets/img/btn_light.png') no-repeat left top;
            background-size: 100% 100%;
        }
        span {
            font-size: .407407rem;
            color: #fff;
            line-height: 1.4;
            letter-spacing: .046296rem;
        }
    }
    .list-btn {
        width: 1.194444rem;
        position: absolute;
        right: .277778rem;
        bottom: .648148rem;
        cursor: pointer;
        .close {
            width: .546296rem;
            height: .546296rem;
            position: absolute;
            top: -0.268519rem;
            right: -0.268519rem;
            background: url('../assets/img/close_btn.png') no-repeat center center;
            background-size: 100% 100%;
        }
    }
    .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        font-size: 0;
        .cloud-01 {
            position: absolute;
            width: .444444rem;
            top: 1.425926rem;
            left: 1.814815rem;
            transform: translateY(-50%);
            animation: floatupdown 2s alternate infinite;
        }
        .cloud-02 {
            position: absolute;
            width: .62963rem;
            top: 2.148148rem;
            right: 1.037037rem;
            transform: translateY(50%);
            animation: floatupdown 3s alternate infinite;
        }
        .cloud-03 {
            position: absolute;
            width: .703704rem;
            top: 5.555556rem;
            left: .814815rem;
            transform: translateY(50%);
            animation: floatupdown 3s alternate infinite;
        }
        .bird {
            width: 2.055556rem;
            position: absolute;
            top: 6rem;
            right: .601852rem;
            transform: translateY(30%);
            opacity: 1;
            animation: floatfade 3s alternate infinite;
        }
        .bus {
            position: absolute;
            width: 59.259vw;
            left: 50%;
            transform: translateX(-50%);
            bottom: 14.444vw;
        }
    }
}

@keyframes floatupdown {
    100% {
        transform: translateY(0);
    }
}

@keyframes floatfade {
    100% {
        transform: translateY(0);
        opacity: 0;
    }
}
</style>
